module.exports = __webpack_public_path__ + "img/content03.a64750fc.png";